import { useAmplitude as usePrivateAmplitude } from '@crehana/analytics';

import { LogEventConfig } from './types';

// This is just a reexport with the types already defined
const useAmplitude = () => usePrivateAmplitude<LogEventConfig>();

export default useAmplitude;
